import { FavySoftwareLayout } from "./FavySoftwareLayout";
import { ThemeContext, WEB_REVIEW_WIDGET } from "./ThemeContext";

export const FavySoftwareWebWidget = (props) => (
	<ThemeContext.Provider value={{ reviewWidget: WEB_REVIEW_WIDGET, ...props }}>
		<FavySoftwareLayout {...props} />
	</ThemeContext.Provider>
);
